<template>
    <basic-header
        pretitle="Administration"
        title="Clients"
        :buttonText="accesss?'Onboard Client':''"
        buttonClass="btn-success"
        :buttonRoles="btnRoles"
        buttonText2="Add Client"
        buttonClass2="btn-primary"
        @btnClick="$router.push('/onboarding')"
        @btnClick2="showModal({ component: 'addClient' })"
    />
    <div class="container-fluid">
        <div class="card">
            <datatable
                tableId="clientsTable"
                :columns="columns"
                uniqueField="cid"
                :data="$store.state.admin.clientList"
                :deletable="$store.getters.userRoles.isAqferAdmin"
                @deleteRows="showDeleteClients"
                :compact="true"
                :select="true"
                :selectCheckboxes="$store.getters.userRoles.isAqferAdmin"
                :detailColumn="{baseUrl:'clients/', identifier:'cid'}"
            />
        </div>
    </div>
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import Datatable from "../../components/Datatable.vue";
import { mapActions } from "vuex";

export default {
    name: "Clients",
    components: { BasicHeader, Datatable },
    data() {
        return {
            columns: [
                { data: "cid" },
                { data: "name" },
                { data: "enabled" },
                { data: "version" },
            ],
            btnRoles: [1, 1.5] // aqfer_admin and aqfer_manager can onboard clients
        };
    },
    beforeMount() {
        this.$store.dispatch("admin/fetchClientList");
    },
    computed: {
        accesss() {
            return this.$store.getters.userRoles.isAccessByRole(this.btnRoles)
        },
    },
    methods: {
        showDeleteClients(rows) {
            this.showModal({ component: "deleteClients", data: rows });
        },
        ...mapActions({
            showModal: "showModal",
        }),
    },
};
</script>

<style>
</style>